import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";
import {LookupService} from "../srvs/lookup";
@Component({
  selector: 'micro-chatSessionLog-detail',
  templateUrl: './chatSessionLog-detail.component.html'
})
export class ChatSessionLogDetailComponent extends BaseComponent {
  chatSessionLog:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              public lookupService:LookupService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/ai/chatSessionLogs/${id}`).subscribe(
            data => {
              this.setChatSessionLog(data)
            }
          );
        }
      });
  }

  setChatSessionLog(chatSessionLog:any) {
    this.chatSessionLog = chatSessionLog;
  }

  createNew() {
    this.chatSessionLog = {
    };
  }

  save() {
    if (!this.chatSessionLog.id) {
      this.http.post(`${this.env.e.url}/chat/chatSessionLogs`, this.chatSessionLog)
        .subscribe(
          data => {
            this.setChatSessionLog(data)
            this.alertService.info(`Created ${this.chatSessionLog.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/chat/chatSessionLogs/${this.chatSessionLog.id}`, this.chatSessionLog)
        .subscribe(
          data => {
            this.setChatSessionLog(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/chat/chatSessionLogs/${this.chatSessionLog.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.chatSessionLog.name}`);
          this.router.navigate(["/chatSessionLogs"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
